<template>
    <main class="main">
        <div class="container-fluid px-0" data-layout="container">

            <aside-main/>

            <header-main/>

            <div class="content">

                <div class="row g-3">
                    <div class="col-sm-6 col-md-6">
                        <h2 class="text-bold text-1100 mb-5">
                            Игры
                            <span class="fw-normal text-700 ms-2">({{items_count}})</span>
                        </h2>
                    </div>
                </div>

                <div class="row align-items-center justify-content-between g-3 mb-3">
                    <div class="col-sm-6 col-md-6">
                        <div class="form-icon-container">
                            <input
                                @input="changeSearch"
                                v-model="search.name"
                                type="text" 
                                placeholder="Название" 
                                class="form-control form-icon-input">
                            <span class="fa-regular fa-magnifying-glass text-500 fs--1 form-icon"></span>
                        </div>
                    </div>

                    <div class="col-sm-6 col-md-6">
                        <div class="form-icon-container">
                            <vue-select
                                @input="changeSearch"
                                v-model="search.provider"
                                :options="utils.providers" 
                                placeholder="Провайдеры"
                                label="name">
                                <template v-slot:no-options="{ search, searching }">
                                  <template v-if="searching">
                                     Ничего не найдено по запросу <em>{{ search }}</em>.
                                  </template>
                                </template>
                            </vue-select>
                        </div>
                    </div>

                    <div class="col-sm-6 col-md-4">
                        <div class="form-icon-container">
                            <vue-select
                                @input="changeSearch"
                                v-model="search.category"
                                :options="utils.categories" 
                                placeholder="Категории"
                                label="name">
                                <template v-slot:no-options="{ search, searching }">
                                  <template v-if="searching">
                                     Ничего не найдено по запросу <em>{{ search }}</em>.
                                  </template>
                                </template>
                            </vue-select>
                        </div>
                    </div>

                    <div class="col-sm-6 col-md-4">
                        <div class="form-icon-container">
                            <vue-select
                                @input="changeSearch"
                                v-model="search.platform"
                                :options="utils.platforms" 
                                placeholder="Платформы"
                                label="name">
                                <template v-slot:no-options="{ search, searching }">
                                  <template v-if="searching">
                                     Ничего не найдено по запросу <em>{{ search }}</em>.
                                  </template>
                                </template>
                            </vue-select>
                        </div>
                    </div>

                    <div class="col-sm-6 col-md-4">
                        <div class="form-icon-container">
                            <vue-select
                                @input="changeSearch"
                                v-model="search.status"
                                :options="utils.statuses" 
                                placeholder="Статус"
                                label="name">
                                <template v-slot:no-options="{ search, searching }">
                                  <template v-if="searching">
                                     Ничего не найдено по запросу <em>{{ search }}</em>.
                                  </template>
                                </template>
                            </vue-select>
                        </div>
                    </div>
                </div>


                <div class="card-body p-0 spinner-center" v-if="preloader">
                    <div class="p-4 code-to-copy">
                        <div class="spinner-border" role="status"></div>
                    </div>
                </div>


                <div class="mx-n4 mx-lg-n6 px-4 px-lg-6 mb-9 bg-white border-y border-300 mt-2 position-relative top-1" v-show="!preloader">
                    <div class="table-responsive scrollbar ms-n1 ps-1">
                    
                        <div class="table table-responsive-small">
                            <datatable
                                :filter="search.search_change"
                                :columns="columns" 
                                :data="getItems"
                                :per-page="pager.per_page">
                                <template scope="{ row, columns }">
                                    <tr>
                                        <td>{{ row.id }}</td>
                                        <td>
                                            <div class="avatar avatar-s  rounded-circle">
                                                <img class="rounded-circle " :src=" `${$config.ApplicationStaticURL}/icos/${row.image}`" alt="">
                                            </div>
                                            <span class="ml-3">{{ row.name }}</span>
                                        </td>
                                        <td>{{ row.played }}</td>
                                        <td>
                                            <template v-if="row.is_mobile">
                                                {{ utils.platforms.find(el => el.key == 'mobile').name }}
                                            </template>
                                            <template v-if="row.is_desktop">
                                                <template v-if="row.is_mobile">
                                                    <br>
                                                </template>
                                                {{ utils.platforms.find(el => el.key == 'desktop').name }}
                                            </template>
                                        </td>
                                        <td>{{ utils.providers.length ? utils.providers.find(el => el.id == row.provider_id).name : null }}</td>
                                        <td>{{ utils.categories.length ? utils.categories.find(el => el.id == row.category_id).name : null }}</td>
                                        <td>{{ utils.statuses.find(el => el.key == row.status).name }}</td>
                                        <td>
                                            <button
                                                @click="changeStatus(row.id)"
                                                :content="row.status == 1 ? 'Отключить' : 'Включить'" 
                                                v-tippy="{arrow : true, arrowType: 'round'}"
                                                :class="{'disabled': status_item_preloader}"
                                                class="btn btn-soft-secondary btn-sm me-1 mb-1">
                                                <span class="spinner-border spinner-border-sm spinner-border-custom-small" role="status" v-if="status_item_preloader && status_item_preloader == row.id"></span>
                                                <i
                                                    v-if="!status_item_preloader || status_item_preloader != row.id"
                                                    :class="{'fa-circle-pause': row.status == 1, 'fa-play': row.status == 0}"
                                                    class="fa-regular fa-circle-pause"></i>
                                            </button>

                                            <router-link  
                                                :to="{name: 'GamesItem', params: {id: row.id}}"
                                                content="Редактировать" 
                                                v-tippy="{arrow : true, arrowType: 'round'}"
                                                class="btn btn-soft-primary btn-sm me-1 mb-1">
                                                <i class="fa-regular fa-pen-to-square"></i>
                                            </router-link>
                                        </td>
                                    </tr>
                                </template>
                            </datatable>
                        </div>

                        <div class="col-auto d-flex">
                            <ul class="mb-3 pagination">
                                <datatable-pager v-model="pager.page" type="abbreviated"></datatable-pager>
                            </ul>
                        </div>

                    </div>
                </div>
                
                <footer-main/>

            </div>

        </div>
    </main>
</template>

<script>
export default {
    props: ['status'],
    data () {
        return {
            preloader: true,
            btn_preloader: false,
            status_item_preloader: false,
            pager: {
                per_page: 25,
                page: 0
            },
            items_count: 0,
            search: {
                search_change: null,
                name: null,
                provider: null,
                category: null,
                platform: null,
                status: null
            },
            columns: [
                {label: 'ID', field: 'id', sortable: true},
                {label: 'Название'},
                {label: 'Кол. Игр', field: 'played', sortable: true},
                {label: 'Платформа'},
                {label: 'Провайдер'},
                {label: 'Категория'},
                {label: 'Статус'},
                {label: ''}
            ],
            utils: {
                providers: [],
                categories: [],
                platforms: [
                    {
                        name: 'Desktop',
                        key: 'desktop'
                    },
                    {
                        name: 'Mobile',
                        key: 'mobile'
                    }
                ],
                statuses: [
                    {
                        name: 'Включена',
                        key: 1
                    },
                    {
                        name: 'Отключена',
                        key: 0
                    }
                ]
            }
        }
    },
    methods: {
        async getItems ({ sortBy, sortDir, perPage, page }) {
            this.preloader = true

            var items = await this.$axios.post('/games/items', JSON.stringify({
                pager: {
                    per_page: this.pager.per_page,
                    page: page - 1
                },
                sort: {
                    by: sortBy,
                    dir: sortDir
                },
                search: {
                    name: this.search.name,
                    provider: this.search.provider != null ? this.search.provider.id : null,
                    category: this.search.category != null ? this.search.category.id : null,
                    platform: this.search.platform != null ? this.search.platform.key : null,
                    status: this.search.status != null ? this.search.status.key : null
                }
            }))
            .then((response) => {
                this.preloader = false
                this.setUser(response.data.user)
                return response.data
            }).catch((error) => {
                let response = error.response.data
                this.setUser(response.user)

                if('status' in response && response.status == 'error') {
                    this.$toast.error(response.message)
                }
            })

            if(items && items.status == 'success') {
                this.items_count = items.data.count
                return {
                    rows: items.data.items,
                    totalRowCount: items.data.count
                }
            }

            return {
                rows: [],
                totalRowCount: 0
            }
        },
        async getProviders () {
            await this.$axios.post('/games/providers/items', JSON.stringify({
                search: {
                    name: null,
                    status: null
                }
            }))
            .then((response) => {
                this.preloader = false
                response = response.data
                switch (response.status) {
                    case 'error':
                        this.$toast.error(response.message)
                        break
                    case 'success':
                        for (let item of response.data) {
                            this.utils.providers.push({
                                name: item.name,
                                id: item.id
                            })
                        }

                        this.setUser(response.user)
                        break
                    default:
                        this.$toast.error('Unknown error')
                }
            }).catch((error) => {
                let response = error.response.data
                this.setUser(response.user)

                if('status' in response && response.status == 'error') {
                    this.$toast.error(response.message)
                }
            })     
        },
        async getCategories () {
            await this.$axios.post('/games/categories/items', JSON.stringify({
                search: {
                    name: null,
                    status: null
                }
            }))
            .then((response) => {
                this.preloader = false
                response = response.data
                switch (response.status) {
                    case 'error':
                        this.$toast.error(response.message)
                        break
                    case 'success':
                        for (let item of response.data) {
                            this.utils.categories.push({
                                name: item.name,
                                id: item.id
                            })
                        }

                        this.setUser(response.user)
                        break
                    default:
                        this.$toast.error('Unknown error')
                }
            }).catch((error) => {
                let response = error.response.data
                this.setUser(response.user)

                if('status' in response && response.status == 'error') {
                    this.$toast.error(response.message)
                }
            })     
        },
        changeStatus (id) {
            this.status_item_preloader = id
            this.$axios.post(`/games/changestatus/${id}`)
            .then((response) => {
                this.status_item_preloader = false
                response = response.data
                switch (response.status) {
                    case 'error':
                        this.$toast.error(response.message)
                        break
                    case 'success':
                        this.changeSearch()

                        this.setUser(response.user)
                        break
                    default:
                        this.$toast.error('Unknown error')
                }
            }).catch((error) => {
                let response = error.response.data
                this.setUser(response.user)
                
                if('status' in response && response.status == 'error') {
                    this.$toast.error(response.message)
                }
            })     
        },
        changeSearch () {
            this.search.search_change = String(Date.now())
        }
    },
    async beforeMount () {
        await this.getProviders()
        await this.getCategories()
    }
}
</script>
